import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f40a8cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-sensors-exposure-property-prop"];
const _hoisted_2 = {
  class: "form-container"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 0,
  class: "code-msg"
};
const _hoisted_6 = {
  key: 1
};
import { ref, reactive, inject } from 'vue';
import { getSmsCode, sendCustomInfo } from '@/api/index';
import { isMobile } from '@/utils';
import { message } from 'ant-design-vue';
import { REGEXP } from '@/utils/valid';
import { $track } from '@/plugins/Track';
export default {
  __name: 'form',
  props: {
    mainTitle: String,
    desc: String,
    method: String
  },
  setup(__props) {
    const props = __props;
    const userMsg = ref(null);
    const waitTime = ref(0);
    const isLoading = ref(false);
    const closeFormModal = inject('closeFormModal');
    // form default data
    const defaultData = {
      customerName: '',
      companyName: '',
      phone: '',
      smsCode: '',
      type: 0,
      remember: false
    };
    const user = reactive({
      ...defaultData
    });

    // 获取二维码
    const getCode = async () => {
      try {
        const res = await getSmsCode(user);
        message[res.status === 200 ? 'success' : 'warning'](res.message);
        waitTime.value = 60;
        const timer = setInterval(() => {
          waitTime.value -= 1;
          if (!waitTime.value || waitTime.value <= 0) {
            clearInterval(timer);
          }
        }, 1000);
      } catch (e) {}
    };
    const matchPhone = ref(false);
    const checkPhone = () => {
      matchPhone.value = user.phone && REGEXP.phone.test(user.phone);
    };

    // 提交用户信息
    const onFinish = async () => {
      try {
        isLoading.value = true;
        sendUserInfo();
        const res = await sendCustomInfo(user);
        isLoading.value = false;
        waitTime.value = 0;
        matchPhone.value = false;
        if (res.status === 200) {
          userMsg.value.resetFields();
          closeFormModal();
          return message.success(res.message, 3);
        }
        return message.error(res.message, 3);
      } catch (e) {
        isLoading.value = false;
      }
    };
    // 跳转到隐私
    const openPrivacy = name => {
      window.open(window.appConfig[name], '_blank');
    };

    // 手机号录入成功后上报
    const sendUserMobile = () => {
      if (matchPhone.value) {
        sendUserInfo(false);
      }
    };

    // 上报用户信息
    const sendUserInfo = (isSubmit = true) => {
      $track('CustomerLeads', {
        leads_user_name: user.customerName,
        leads_corporate_name: user.companyName,
        leads_user_mobile: user.phone,
        leads_source: '落地页' + (props.method || ''),
        leads_is_submit: isSubmit
      });
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createBlock(_component_a_spin, {
        spinning: isLoading.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "form",
          "data-sensors-exposure-event-name": "activity",
          "data-sensors-exposure-config-area_rate": "0.5",
          "data-sensors-exposure-config-stay_duration": "0",
          "data-sensors-exposure-config-repeated": "true",
          "data-sensors-exposure-property-prop": _unref(isMobile)() ? 'H5电子合同落地页_顶部留资' : 'PC电子合同落地页_顶部留资'
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(props.mainTitle), 1), _createElementVNode("div", {
          class: "description",
          innerHTML: props.desc
        }, null, 8, _hoisted_4), _createVNode(_component_a_form, {
          ref_key: "userMsg",
          ref: userMsg,
          model: user,
          name: "customerName",
          "hide-required-mark": true,
          layout: "horizontal",
          onFinish: onFinish
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            name: "customerName",
            rules: [{
              required: true,
              pattern: _unref(REGEXP).name,
              message: '请输入姓名'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.customerName,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => user.customerName = $event),
              placeholder: "姓名"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, {
            name: "companyName",
            rules: [{
              pattern: _unref(REGEXP).companyName,
              message: '请输入公司名称'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.companyName,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => user.companyName = $event),
              placeholder: "公司名称（选填）"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, {
            name: "phone",
            rules: [{
              required: true,
              pattern: _unref(REGEXP).phone,
              message: '请输入手机号'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.phone,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => user.phone = $event),
              onBlur: _cache[3] || (_cache[3] = $event => sendUserMobile()),
              onInput: _cache[4] || (_cache[4] = $event => checkPhone()),
              placeholder: "手机号"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, {
            name: "smsCode",
            rules: [{
              required: true,
              pattern: _unref(REGEXP).captcha,
              message: '验证码错误'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.smsCode,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => user.smsCode = $event),
              placeholder: "验证码"
            }, null, 8, ["value"]), matchPhone.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [waitTime.value <= 0 ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:void(0)",
              onClick: _cache[6] || (_cache[6] = $event => getCode())
            }, "获取验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(waitTime.value) + " s", 1))])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, {
            name: "remember"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_checkbox, {
              checked: user.remember,
              "onUpdate:checked": _cache[9] || (_cache[9] = $event => user.remember = $event)
            }, {
              default: _withCtx(() => [_createTextVNode("我已阅读并同意 "), _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[7] || (_cache[7] = $event => openPrivacy('policy'))
              }, "《用户协议》"), _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[8] || (_cache[8] = $event => openPrivacy('privacy'))
              }, "《隐私政策》")]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            class: "noboder"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              disabled: !user.remember
            }, {
              default: _withCtx(() => [_createTextVNode("免费试用")]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])], 8, _hoisted_1)]),
        _: 1
      }, 8, ["spinning"]);
    };
  }
};